<template>
  <div id="profit">
    <nav-common></nav-common>
    <div class="chart-box">
      <div class="chart-control">
        <el-switch
          v-model="chartType"
          @change="getvisual(0,chartType)"
          active-value="2"
          inactive-value="1"
          active-text="最近一年"
          inactive-text="最近半年">
        </el-switch>
        <!-- <p class="search-title">定制查询：</p>
        <div class="picker-box">
            <div class="block">
              <el-date-picker
                v-model="startDate"
                type="month"
                value-format="yyyy-MM-dd"
                placeholder="开始日期">
              </el-date-picker>
            </div>
            <div class="sep">-</div>
            <div class="block">
              <el-date-picker
                v-model="endDate"
                type="month"
                @change="searchVis()"
                value-format="yyyy-MM-dd"
                placeholder="结束日期">
              </el-date-picker>
            </div>
          </div> -->
      </div>
      <div class="chart-item">
        <schart :canvasId="chartPie.canvasId"
            :type="chartPie.type"
            :width="chartPie.width"
            :height="chartPie.height"
            :data="chartPie.data"
            :options="chartPie.options"
        ></schart>
      </div>
    </div>
    <div class="profit-content">
      <el-tabs type="border-card" @tab-click="handleClick">
        <el-tab-pane label="本级分润查询">
          <el-table
            :data="profit.data"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="bank_name"
              label="渠道"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="agent.leading_official"
              label="代理商"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="sub_agent"
              label="子代理商"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="money"
              label="办卡提成"
              align="center"
              width="90">
            </el-table-column>
            <el-table-column
              prop="first_use_reward"
              label="首刷奖励"
              align="center"
              width="90">
            </el-table-column>
            <el-table-column
              prop="card.name"
              label="姓名"
              align="center"
              width="123">
            </el-table-column>
            <el-table-column
              prop="card.id_card"
              label="身份证"
              align="center"
              width="220">
            </el-table-column>
            <el-table-column
              prop="card.phone"
              label="手机号"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="生成时间"
              align="center"
              width="180">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="profit.per_page"
            @current-change="getprofit"
            :current-page="profit.current_page"
            :total="profit.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="二级分润查询">
          <el-table
            :data="profit.data"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="bank_name"
              label="渠道"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="agent.leading_official"
              label="代理商"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="sub_agent"
              label="子代理商"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="money"
              label="办卡提成"
              align="center"
              width="90">
            </el-table-column>
            <el-table-column
              prop="first_use_reward"
              label="首刷奖励"
              align="center"
              width="90">
            </el-table-column>
            <el-table-column
              prop="card.name"
              label="姓名"
              align="center"
              width="123">
            </el-table-column>
            <el-table-column
              prop="card.id_card"
              label="身份证"
              align="center"
              width="220">
            </el-table-column>
            <el-table-column
              prop="card.phone"
              label="手机号"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="生成时间"
              align="center"
              width="180">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="profit.per_page"
            @current-change="getprofit"
            :current-page="profit.current_page"
            :total="profit.total">
          </el-pagination>
        </el-tab-pane>
        <!-- <el-tab-pane label="三分润查询">
          <el-table
            :data="profit.data"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="bank_name"
              label="渠道"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="agent.leading_official"
              label="代理商"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="sub_agent"
              label="子代理商"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="money"
              label="办卡提成"
              align="center"
              width="90">
            </el-table-column>
            <el-table-column
              prop="first_use_reward"
              label="首刷奖励"
              align="center"
              width="90">
            </el-table-column>
            <el-table-column
              prop="card.name"
              label="姓名"
              align="center"
              width="123">
            </el-table-column>
            <el-table-column
              prop="card.id_card"
              label="身份证"
              align="center"
              width="220">
            </el-table-column>
            <el-table-column
              prop="card.phone"
              label="手机号"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="生成时间"
              align="center"
              width="180">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="profit.per_page"
            @current-change="getprofit"
            :current-page="profit.current_page"
            :total="profit.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="四级分润查询">
          <el-table
            :data="profit.data"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="bank_name"
              label="渠道"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="agent.leading_official"
              label="代理商"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="sub_agent"
              label="子代理商"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="money"
              label="办卡提成"
              align="center"
              width="90">
            </el-table-column>
            <el-table-column
              prop="first_use_reward"
              label="首刷奖励"
              align="center"
              width="90">
            </el-table-column>
            <el-table-column
              prop="card.name"
              label="姓名"
              align="center"
              width="123">
            </el-table-column>
            <el-table-column
              prop="card.id_card"
              label="身份证"
              align="center"
              width="220">
            </el-table-column>
            <el-table-column
              prop="card.phone"
              label="手机号"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="生成时间"
              align="center"
              width="180">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="profit.per_page"
            @current-change="getprofit"
            :current-page="profit.current_page"
            :total="profit.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="五级分润查询">
          <el-table
            :data="profit.data"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="bank_name"
              label="渠道"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="agent.leading_official"
              label="代理商"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="sub_agent"
              label="子代理商"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="money"
              label="办卡提成"
              align="center"
              width="90">
            </el-table-column>
            <el-table-column
              prop="first_use_reward"
              label="首刷奖励"
              align="center"
              width="90">
            </el-table-column>
            <el-table-column
              prop="card.name"
              label="姓名"
              align="center"
              width="123">
            </el-table-column>
            <el-table-column
              prop="card.id_card"
              label="身份证"
              align="center"
              width="220">
            </el-table-column>
            <el-table-column
              prop="card.phone"
              label="手机号"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="生成时间"
              align="center"
              width="180">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="profit.per_page"
            @current-change="getprofit"
            :current-page="profit.current_page"
            :total="profit.total">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="六级分润查询">
          <el-table
            :data="profit.data"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="bank_name"
              label="渠道"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="agent.leading_official"
              label="代理商"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="sub_agent"
              label="子代理商"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="money"
              label="办卡提成"
              align="center"
              width="90">
            </el-table-column>
            <el-table-column
              prop="first_use_reward"
              label="首刷奖励"
              align="center"
              width="90">
            </el-table-column>
            <el-table-column
              prop="card.name"
              label="姓名"
              align="center"
              width="123">
            </el-table-column>
            <el-table-column
              prop="card.id_card"
              label="身份证"
              align="center"
              width="220">
            </el-table-column>
            <el-table-column
              prop="card.phone"
              label="手机号"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="生成时间"
              align="center"
              width="180">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="profit.per_page"
            @current-change="getprofit"
            :current-page="profit.current_page"
            :total="profit.total">
          </el-pagination>
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Schart from 'vue-schart';
import NavCommon from '@/components/navtop/navcommon'

export default {
  name: 'Profit',
  data () {
    return {
      profit: {},
      params: 'self',
      chartType: 1,
      date: '',
      startDate: '',
      endDate: '',
      chartPie: {
        canvasId: 'pieCanvas',
        type: 'line',
        width: 1000,
        height: 300,
        data: [
          {name: '2016-10', value: 1342},
          {name: '2016-10', value: 2123},
        ],
        options: {
          title: '分润记录'
        }
      }
    }
  },
  created() {
    this.getprofit(1);
    this.getvisual(0);
  },
  methods: {
    handleClick(tab, event) {
      var index = parseInt(tab.index);
      var _this = this;
      switch(index) {
        case 0:
          _this.params = 'self';
          _this.getprofit(1);
          break;
        case 1:
          _this.params = 'sub';
          _this.getprofit(1);
          break;
        case 2:
          _this.params = 'subsub';
          _this.getprofit(1);
          break;
        case 3:
          _this.params = 'fourth';
          _this.getprofit(1);
          break;
        case 4:
          _this.params = 'fifth';
          _this.getprofit(1);
          break;
        case 5:
          _this.params = 'sixth';
          _this.getprofit(1);
          break;
        default:
          return;
        };
    },
    getprofit(page) {
      var _this = this;
      _this.$http({
        method: 'get',
        url: _this.$api + '/service/agent/profit/' + _this.params + '?page=' + page
      }).then((res) => {
        _this.profit = res.data.data;
      })
    },
    getvisual(type,date) {
      let _this = this;
      _this.$http({
        method: 'get',
        url: _this.$api + '/service/agent/visual/profit?type=' + type + '&date=' + date
      }).then((res) => {
        if(res.data.code == 200) {
            let data = res.data.data;
            _this.chartPie.data = data;
  			} else {

  			}
      })
    },
    searchVis() {
      let _this = this;
      let startDate = _this.startDate.split('-').slice(0,2).join('-');
      let endDate = _this.endDate.split('-').slice(0,2).join('-');
      let date = startDate + '|' + endDate;
    }
  },
  components: {
    Schart,
    NavCommon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .profit-content
    position relative
    margin 20px
    padding 60px 40px 20px 40px
    background #f8f8f8
    box-shadow 3px 3px 3px #f5f5f5 inset
  .chart-box
    position relative
    width 100%
    height 320px
    padding 20px 0 10px 0
    .chart-item
      position absolute
      width 1000px
      top 40px
      left 50%
      margin-left -500px
    .search-title
      height 40px
      line-height 40px
      font-size 14px
    .chart-control
      padding-left 115px
      .picker-box
        display flex
        .el-date-editor.el-input, .el-date-editor.el-input__inner
          width 120px
        .sep
          line-height 40px
          margin 0 5px
</style>



// WEBPACK FOOTER //
// src/components/profit/profit.vue